<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <ElSelect
            v-model="fieldValue"
            class="search-preference__select"
            size="small"
            :placeholder="$t(fieldConfig.label)"
            @change="syncChange"
        >
            <ElOption
                v-for="option in finalLimitOptions"
                :key="option.value"
                :value="option.value"
                :disabled="option.disabled"
            >
                <ElTooltip
                    v-if="option.tooltip"
                    placement="right-start"
                    effect="light"
                    :visible-arrow="false"
                    :content="option.tooltip"
                >
                    <span>{{ option.label }}</span>
                </ElTooltip>
                <span v-else>
                    {{ option.label }}
                </span>
            </ElOption>
        </ElSelect>
    </FieldItem>
</template>

<script>
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import Tooltip from 'element-ui/lib/tooltip';
import map from 'lodash/map';
import assign from 'lodash/assign';
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';
import { targetSeqLimitOptions } from '../constants/constantConfig';

export default {
    components: {
        FieldItem,
        ElSelect: Select,
        ElOption: Option,
        ElTooltip: Tooltip,
    },
    mixins: [FieldItemMixin],
    inject: {
        store: {
            from: 'store',
        },
        state: {
            from: 'state',
            default: null,
        },
    },
    props: {
        fieldName: {
            type: String,
            default: 'limit',
        },
        amountLimit: {
            type: Boolean,
            default: true,
        },
        limitOptions: {
            type: Array,
            default: () => [],
        },
        isCnRegion: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        proxyAmountLimit() {
            if (this.state && 'amountLimit' in this.state) {
                return this.state.amountLimit;
            }
            return this.amountLimit;
        },
        proxyCnRegion() {
            if (this.state && 'isCnRegion' in this.state) {
                return this.state.isCnRegion;
            }
            return this.isCnRegion;
        },
        defaultLimitOptions() {
            const options = map(targetSeqLimitOptions, (opt) => assign(
                { ...opt },
                opt.value === 50000 && this.proxyAmountLimit && !this.proxyCnRegion
                    ? {
                        disabled: true,
                        tooltip: this.$tc(
                            'Search.labels.targetSeqLimitTooltip',
                        ),
                    } : {},
            ));
            // CN环境下，无权限时直接过滤掉
            if (this.proxyCnRegion) {
                return options.filter(opt => !(opt.value === 50000 && this.proxyAmountLimit));
            }
            return options;
        },
        finalLimitOptions() {
            return this.limitOptions?.length > 0 ? this.limitOptions : this.defaultLimitOptions;
        },
    },
};
</script>
